import { postSupportTicket, postSupportTicketMediaItem } from '@cbgms/api'
import { PostSupportTicket } from '@cbgms/api/modules/orderaccount/types'
import { useMutation } from '@tanstack/react-query'
import { useDispatch } from 'react-redux'

interface Props extends Omit<PostSupportTicket, 'Attachments'> {
  Uploads: File[]
}

export function useSupportTicket() {
  const dispatch = useDispatch()

  return useMutation(async ({ WholesalerUUID, TicketType, Question, Uploads, Vehicle, Part, CallbackDetails }: Props) => {
    // Upload images relative path can be attachted to ticket by Key.
    const data = await Promise.all(Uploads.map(file => dispatch(postSupportTicketMediaItem(file))))
    const Attachments = data?.map(item => ({ Key: item.Data.RelativePath }))
    await dispatch(postSupportTicket({ Attachments, Question, Vehicle, WholesalerUUID, TicketType, Part, CallbackDetails }))
  })
}
